export enum APIErrorTypes {
  generic = 'err.generic',
  validation = 'err.validation',
  gemini = 'err.geminiRequestError',
  entityNotFound = 'err.entityDoesNotExist',
  permissions = 'err.permissions',
  unprocessableEntity = 'err.unprocessableEntity',
  IncompatiblePaymentRail = 'err.bankAccountDoesNotSupportPaymentRail',
  InsufficientRefundBalance = 'err.insufficientRefundBalance',
  InsufficientRefundFunds = 'err.refund.insufficient_funds',
}

export const isInsufficientRefundFundsError = (errorType?: string) =>
  errorType === APIErrorTypes.InsufficientRefundBalance || errorType === APIErrorTypes.InsufficientRefundFunds;

export interface FailedAttributes {
  attributeName: string;
  message: string;
  path: string;
}

export interface ValidationErrorMeta {
  validationErrorMessage: string;
  failedAttributes: Array<FailedAttributes>;
  code: string;
  source: {
    key: Record<string, string>;
  };
}

export interface APIError {
  errorMessage: string;
  errorType: APIErrorTypes;
  meta: Record<string, any>;
  requestId: string;
}

export interface ValidationAPIError extends Omit<APIError, 'meta'> {
  meta: Partial<ValidationErrorMeta>;
}
